export default function LiveCasinoIcon({ 
  fill = "#7179A5",
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.45269 4.16734C5.17574 3.8904 4.71724 3.86672 4.42633 4.15663C2.9278 5.65009 2 7.71704 2 10.0002C2 12.3722 3.00138 14.5108 4.60373 16.0154C4.89644 16.2903 5.34261 16.2612 5.61363 15.9901C5.92967 15.6741 5.89122 15.1715 5.58652 14.8802C4.30051 13.6509 3.5 11.9193 3.5 10.0002C3.5 8.15372 4.2411 6.4808 5.44265 5.26187C5.73286 4.96746 5.76226 4.47691 5.45269 4.16734Z"
        fill="currentColor"
      />
      <path
        d="M7.21439 5.92891C6.94521 5.65973 6.4954 5.6261 6.20574 5.91273C5.15279 6.95464 4.5 8.40136 4.5 10.0001C4.5 11.6916 5.2307 13.2128 6.39289 14.2645C6.6846 14.5286 7.11579 14.4878 7.37618 14.2275C7.70433 13.8993 7.64255 13.3829 7.33502 13.0929C6.51275 12.3176 6 11.2189 6 10.0001C6 8.84943 6.45694 7.80602 7.1998 7.04055C7.48609 6.74555 7.53257 6.24709 7.21439 5.92891Z"
        fill="currentColor"
      />
      <path
        d="M12.7856 5.92891C13.0548 5.65973 13.5046 5.6261 13.7943 5.91273C14.8472 6.95464 15.5 8.40136 15.5 10.0001C15.5 11.6916 14.7693 13.2128 13.6071 14.2645C13.3154 14.5286 12.8842 14.4878 12.6238 14.2275C12.2957 13.8993 12.3574 13.3829 12.665 13.0929C13.4873 12.3176 14 11.2189 14 10.0001C14 8.84943 13.5431 7.80602 12.8002 7.04055C12.5139 6.74555 12.4674 6.24709 12.7856 5.92891Z"
        fill="currentColor"
      />
      <path
        d="M14.5473 4.16734C14.8243 3.8904 15.2828 3.86672 15.5737 4.15663C17.0722 5.65009 18 7.71704 18 10.0002C18 12.3722 16.9986 14.5108 15.3963 16.0154C15.1036 16.2903 14.6574 16.2612 14.3864 15.9901C14.0703 15.6741 14.1088 15.1715 14.4135 14.8802C15.6995 13.6509 16.5 11.9193 16.5 10.0002C16.5 8.15372 15.7589 6.4808 14.5573 5.26187C14.2671 4.96746 14.2377 4.47691 14.5473 4.16734Z"
        fill="currentColor"
      />
      <path
        d="M10 8.50012C9.17157 8.50012 8.5 9.17169 8.5 10.0001C8.5 10.8285 9.17157 11.5001 10 11.5001C10.8284 11.5001 11.5 10.8285 11.5 10.0001C11.5 9.17169 10.8284 8.50012 10 8.50012Z"
        fill="currentColor"
      />
    </svg>
  );
}
